import { render, staticRenderFns } from "./CloseServiceRequestDialog.vue?vue&type=template&id=23d56093&scoped=true&"
import script from "./CloseServiceRequestDialog.vue?vue&type=script&lang=js&"
export * from "./CloseServiceRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d56093",
  null
  
)

export default component.exports